import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { EStampMockup, MonitorMockup, ProcurementMockup, RentMockup, EventsMockup } from "@/components/mockups/DashboardMockups";

const products = [
    { slug: "estamp", name: "Colecle eStamp", tagline: "Digital Stamping & Verification", MockupComp: EStampMockup, num: "01" },
    { slug: "monitor", name: "Colecle Monitor", tagline: "ICT Infrastructure Intelligence", MockupComp: MonitorMockup, num: "02" },
    { slug: "procurement", name: "Procurement & Contracts", tagline: "End-to-End Lifecycle Governance", MockupComp: ProcurementMockup, num: "03" },
    { slug: "rent", name: "Colecle Rent", tagline: "Smart Property & Rental", MockupComp: RentMockup, num: "04" },
    { slug: "events", name: "Colecle Events", tagline: "Enterprise Event Governance", MockupComp: EventsMockup, num: "05" },
];

export default function ProductsIndex() {
    return (
        <main data-testid="products-index" className="pt-[72px] bg-[#F7F9FC] min-h-screen">
            <section className="bg-[#0B1930] text-white pt-24 pb-16 relative overflow-hidden grain">
                <div className="hero-glow top-[-20%] left-[10%]" style={{ background: "#2563EB" }} />
                <div className="max-w-[1400px] mx-auto px-6 lg:px-10 relative">
                    <div className="eyebrow">Products</div>
                    <h1 className="headline text-5xl md:text-6xl lg:text-7xl mt-6 max-w-3xl">
                        Five enterprise products. <em className="not-italic text-[#E8B923]">One ecosystem.</em>
                    </h1>
                </div>
            </section>
            <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 lg:py-24">
                <div className="grid gap-6">
                    {products.map((p, i) => {
                        const { MockupComp } = p;
                        return (
                            <motion.div key={p.slug} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: i * 0.05 }}>
                                <Link to={`/products/${p.slug}`} data-testid={`products-index-${p.slug}`} className="grid lg:grid-cols-12 gap-8 items-center bg-white border border-slate-200 rounded-2xl p-8 lg:p-10 hover:border-navy transition group">
                                    <div className="lg:col-span-5">
                                        <div className="flex items-center gap-3 mb-4">
                                            <span className="font-mono text-xs text-slate-400">{p.num}</span>
                                            <span className="w-1 h-1 rounded-full bg-slate-300" />
                                            <span className="font-mono text-[10px] tracking-widest uppercase text-slate-500">{p.tagline}</span>
                                        </div>
                                        <h2 className="font-serif text-3xl md:text-4xl text-navy">{p.name}</h2>
                                        <div className="mt-6 flex items-center gap-2 text-navy text-sm">
                                            <span>Explore product</span>
                                            <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition" />
                                        </div>
                                    </div>
                                    <div className="lg:col-span-7">
                                        <MockupComp />
                                    </div>
                                </Link>
                            </motion.div>
                        );
                    })}
                </div>
            </section>
        </main>
    );
}
